import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.66699 8.5C2.94313 8.5 3.16699 8.72386 3.16699 9V13C3.16699 13.092 3.24161 13.1667 3.33366 13.1667H12.667C12.759 13.1667 12.8337 13.092 12.8337 13V9C12.8337 8.72386 13.0575 8.5 13.3337 8.5C13.6098 8.5 13.8337 8.72386 13.8337 9V13C13.8337 13.6443 13.3113 14.1667 12.667 14.1667H3.33366C2.68933 14.1667 2.16699 13.6443 2.16699 13V9C2.16699 8.72386 2.39085 8.5 2.66699 8.5Z",
		fill: "#959595"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.00033 1.83331C8.13496 1.83331 8.26391 1.88761 8.358 1.98392L11.6913 5.39627C11.8843 5.59381 11.8806 5.91037 11.683 6.10333C11.4855 6.29629 11.169 6.29258 10.976 6.09505L8.50033 3.5607V11C8.50033 11.2761 8.27647 11.5 8.00033 11.5C7.72418 11.5 7.50033 11.2761 7.50033 11V3.5607L5.02466 6.09505C4.8317 6.29258 4.51514 6.29629 4.3176 6.10333C4.12007 5.91037 4.11636 5.59381 4.30932 5.39627L7.64266 1.98392C7.73674 1.88761 7.86569 1.83331 8.00033 1.83331Z",
		fill: "#959595"
	})]
});
export default SvgIconUpload;
